import Typography from '@mui/material/Typography'
import React from 'react'

import Box from '../../Theme/Box'
import Chip from '../../Theme/Chip'

// TODO need skeleton and isLoading prop
const ContestGameTypes = ({ gameTypeNames = [] }) =>
  !!gameTypeNames.length && (
    <Box>
      <Box pb={2}>
        <Typography
          variant="h6"
          color="text.secondary"
        >
          Supported Gametypes
        </Typography>
      </Box>
      <Box
        sx={(theme) => ({
          display: 'flex',
          gap: theme.spacing(1),
          flexWrap: 'wrap',
          marginBottom: theme.spacing(2),
        })}
      >
        {gameTypeNames.map((name) => (
          <Chip
            key={name}
            label={name}
            variant="outlined"
            sx={{ padding: '4px 12px' }}
          />
        ))}
      </Box>
    </Box>
  )

export default ContestGameTypes
